import * as React from "react";

import { formatCurrency } from "app/utils/filters";
import BackOfficeAndSnapminLink from "app/components/BOComponents/BackOfficeAndSnapminLink";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";
import BackOfficeLink from "app/components/BOComponents/BackOfficeLink";
import MerchantPopover from "../Merchants/MerchantPopover";

const columnConfigs: ColumnConfig[] = [
  {
    name: "Name",
    render: row => (
      <MerchantPopover data={row.merchant}>
        <BackOfficeAndSnapminLink
          backofficeUrl={`/snapscan/ops/merchants/${row.merchant.id}/payments`}
          snapminUrl={row.merchant.snapmin_url}
        >
          {row.merchant.name}
        </BackOfficeAndSnapminLink>
      </MerchantPopover>
    )
  },
  {
    name: "Limit category",
    render: row => {
      const name = row.merchant.merchant_limit_configuration.name;
      return (
        <BackOfficeLink
          backofficeUrl={`/snapscan/fraud/merchant_limit_configs/${name}/summary`}
        >
          {name}
        </BackOfficeLink>
      );
    }
  },
  {
    name: "Transactions",
    cellProps: { align: "right" },
    render: row => row.transactions
  },
  {
    name: "Volume",
    cellProps: { align: "right" },
    render: row => `R${formatCurrency(row.volume)}`
  },
  {
    name: "Highest Tx",
    cellProps: { align: "right" },
    render: row => `R${formatCurrency(row.highest_tx)}`
  },
  {
    name: "Average Tx",
    cellProps: { align: "right" },
    render: row => `R${formatCurrency(row.average_tx)}`
  }
];

export default columnConfigs;
